import React from "react";

export default function ButtonWithSound(props) {
  const playSound = () => {
    const audio = new Audio("/btn-click.mp3");
    audio.play();
  };
  const onclick = () => {
    playSound();
    props?.onClick && props.onClick();
  };
  return (
    <button {...props} onClick={onclick}>
      {props.children}
    </button>
  );
}
